import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { motion } from 'framer-motion';

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  return (
    <motion.button
      onClick={() => loginWithRedirect()}
      className="border border-blue-600 text-blue-600 font-medium py-2 bg-white px-5 rounded-lg transition-all duration-300 hover:bg-blue-600 hover:text-white"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      Log In
    </motion.button>
  );
}

export default LoginButton; 